<template>
  <div class="available-documents">
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AvailableDocuments'
}
</script>
